import React, { createRef, useState, useEffect } from "react";
import { Button, Modal, Form, InputGroup } from 'react-bootstrap';
import InputGroupText from "react-bootstrap/esm/InputGroupText";

import { Datatable } from '../../../../shared/datatable/Datatable';
import { SelectInput, TextInput } from "../../../../shared/form/FormInput";
import { Validators } from "../../../../shared/utils/Validators";

import { departmentList, departmentAdd, departmentDetail, departmentUpdate, locationList } from "../../../../shared/settings/apiConfig";
import { postApi, putApi } from "../../../../shared/services/apiHelper";

import './Department.scss';

const Department = (props) => {
    const dataTable = createRef();

    const getDepartmentForm = (title='', locationid='', adminname='', email='', phonenumber='') => {
        return {
            title: { value: title, valid: false, error: '', validators: [Validators.required()] },
            locationid: { value: locationid, valid: false, error: '', validators: [Validators.required()] },
            adminname: { value: adminname, valid: false, error: '', validators: [Validators.required()] },
            email: { value: email, valid: false, error: '', validators: [Validators.email()] },
            phonenumber: { value: phonenumber, valid: false, error: '', validators: [Validators.phoneNumberValid()] },
        };
    };

    const [locationListData, setLocationList] = useState([]);
    const [departmentForm, setDepartmentForm] = useState(getDepartmentForm());
    const [formValid, setFormValid] = useState(false);
    const [departmentModal, setDepartmentModal] = useState(false);
    const [departmentDetailData, setDepartmentDetailData] = useState({});
    const [message, setMessage] = useState({type: '', message: ''});
    const [search, setSearch] = useState("");
    const [formLoading, setFormLoading] = useState(false);

    const editAction = (id) => {
        const payload = {
            "field": ["id", "title", "description", "status", "adminname", "email", "phonenumber", "locationid"]
          }
        postApi(`${departmentDetail}/${id}`, payload).then((response) => {
            const data = response.data.data[0];
            setDepartmentDetailData(data);
            openDepartmentModal(data);
        }).catch((error) => {
            console.log(error);
        });
    }

    const [config, setConfig] = useState({
        name: 'department',
        url: departmentList,
        columns: [
            { name: 'Department', property: 'title', sort: false, width: '250px' },
            { name: 'Primary Contact', property: 'phonenumber', sort: false, width: '200px' },
            { name: 'Location', property: 'locationtitle', sort: false, width: '250px' },
            {
                name: '', property: '', columnType: 'actions', width: '150px',
                actions: {
                    header: "",
                    row: [
                        {
                            type: 'edit',
                            action: editAction
                        }
                    ]
                }
            },
        ],
        field: ["id", "phonenumber", "adminname", "email", "mobile", "locationtitle", "title", "locationid", "programs"],
        filter: [],
        sort: [{ "field": "id", "direction": "asc" }],
        pagination: true,
    });

    const openDepartmentModal = (data) => {
        setDepartmentModal(true);

        if ( data ) {
            const formData = getDepartmentForm(data?.title || '', data?.locationid || '', data?.adminname || '', data?.email || '', data?.phonenumber || '');
            for (let key in formData) {
                formData[key] = Validators.validateFormControl(formData[key], formData[key].value)
            }
            setDepartmentForm(formData);
        } else {
            setDepartmentForm(getDepartmentForm());
        }

        getLocationList().then(res => {
            let locationdata = res.map(elem => {
                return { value: elem.id, option: elem.title };
            });
            setLocationList(locationdata);
        })
    }

    const closeDepartmentModal = () => {
        setDepartmentModal(false);
        setDepartmentDetailData({});
        setLocationList([]);
    };

    useEffect(() => {
        setFormValid(Validators.validateForm(departmentForm));
    }, [departmentForm]);

    const inputChange = (type, event) => {
        if (type == 'phonenumber') {
            let value = event.target.value.replace(/[^0-9]/g, '');
            if (value.length > 10) {
                value = value.slice(0, 10);
            }
            event.target.value = value;
        }

        setDepartmentForm(prevState => {
            return {
                ...prevState,
                [type]: Validators.validateFormControl(prevState[type], event.target.value)
            }
        })
    };

    const getLocationList = () => {
        let payload = {
            field: ["id", "title"],
            filter: []
        };
        return new Promise((resolve, reject) => {
            postApi(locationList, payload).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    };

    const addOrUpdateDepartment = (isUpdate, addAnotherDepartment=false, loadProgrammes=false) => {
        let data = {
            "title": departmentForm.title.value,
            "locationid": departmentForm.locationid.value,
            "email": departmentForm.email.value,
            "adminname": departmentForm.adminname.value,
            "phonenumber": departmentForm.phonenumber.value,
        };
        setFormLoading(true)

        if ( isUpdate ) {
            data["id"] = departmentDetailData.id
            putApi(departmentUpdate, { data }).then((response) => {
                setMessage({type: 'success', message: "Department Updated Successfully"});

                dataTable.current?.searchData([]);

                setTimeout(() => {
                    setFormLoading(false)
                    closeDepartmentModal();
                    setMessage({type: '', message: ''});
                }, 2000);

            }).catch((error) => {
                setMessage({type: 'error', message: error.message});
                setTimeout(() => {
                    setFormLoading(false)
                    setMessage({type: '', message: ''});
                }, 2000);
            })
        } else {
            postApi(departmentAdd, { data }).then((response) => {
                setMessage({type: 'success', message: "Department Added Successfully"});
                
                dataTable.current?.searchData([]);

                if ( addAnotherDepartment ) {
                    setDepartmentForm(getDepartmentForm());
                }

                setTimeout(() => {

                    if ( !addAnotherDepartment ) {
                        closeDepartmentModal();
                    }

                    setMessage({type: '', message: ''});

                    if ( loadProgrammes ) {
                        props.history.push('/settings/programmes');
                    }
                    setFormLoading(false)

                }, 2000);

            }).catch((error) => {
                setMessage({type: 'error', message: error.message});
                setTimeout(() => {
                    setFormLoading(false)
                    setMessage({type: '', message: ''});
                }, 2000);
            })
        }
    }

    const clearData = () => {
        setSearch("");
        dataTable.current?.searchData([
            { field: 'title', value: "", op: 'LIKE', 'join': 'OR' }
        ]);
    }

    return (
        <div className="w-100">
            <div className="departments w-100">
                <text className='screen-head'>Departments</text>
                <div className="d-flex w-100 department-section p-3 justify-content-between">
                    <div >
                        {/* <text className="text-primary">Department List</text> */}
                    </div>
                    <div className="width-60 d-flex gap-2 rightcont">
                        <InputGroup className="">
                            <InputGroupText className="search" >
                                <i class="fa fa-search ml-3" ></i>
                            </InputGroupText>
                            <span class="icon-envelope-o"></span>
                            <Form.Control className={`search`} type={'text'} style={{ borderRadius: '0px 5px 5px 0px', borderLeft: 'none' }} name={"search"} placeholder={"search by department name"}
                                onChange={(event) => {
                                    setSearch(event.target.value);

                                    // TODO check if already had a filter
                                    if (event.target.value.length == 0) {
                                        dataTable.current?.searchData([]);
                                    }
                                }}
                                value={search}
                                onKeyPress={(event) => {
                                    if (event?.key === "Enter" && search)
                                        dataTable.current?.searchData([
                                            { field: 'title', value: search, op: 'LIKE', 'join': 'AND' }
                                        ])
                                }} />
                        </InputGroup>
                        <button type="button" className="btn btn-secondary dept-btn" onClick={() => {clearData()}}>Clear</button>
                        <button type="button" onClick={() => { openDepartmentModal(); }} className="btn btn-primary w-50 dept-btn" >Add Department</button>
                    </div>
                </div>
            </div>
            <div style={{ padding: '15px' }}>
                <Datatable ref={dataTable} config={config} />
            </div>

            <Modal className="departments" show={departmentModal} onHide={closeDepartmentModal} size="lg" centered backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title className="text-primary" style={{ fontWeight: 'bold' }}>{departmentDetailData.id ? "Update Department" : 'Add Department'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    
                    <div className="d-flex flex-column w-100 gap-3">
                        
                        <div className="d-flex gap-3">
                            <TextInput type={'text'} name={'departmentName'} label={'Department Name'} placeholder={'Department Name'}  isMandatory={true}
                                value={departmentForm.title.value} error={departmentForm.title.error} onChange={(event) => inputChange("title", event)} />
                            
                            <SelectInput name={'locationid'} label={'Location'} placeholder={'Location'}  isMandatory={true}
                                value={departmentForm.locationid.value} options={locationListData} error={departmentForm.locationid.error} onChange={(event) => inputChange('locationid', event)} />
                        </div>

                        <div className="d-flex gap-3">
                            <TextInput type={'text'} name={'departmentadmin'} label={'Department Admin Name'} placeholder={'Department Admin Name'}  isMandatory={true}
                                value={departmentForm.adminname.value} error={departmentForm.adminname.error} onChange={(event) => inputChange("adminname", event)} />

                            <TextInput type={'text'} name={'email'} label={'Email'} placeholder={'Email'}  isMandatory={true}
                                value={departmentForm.email.value} error={departmentForm.email.error} onChange={(event) => inputChange("email", event)} />
                        </div>

                        <div>
                            <TextInput type={'number'} name={'phonenumber'} label={'Phone number'} placeholder={'Phone number'}  isMandatory={true}
                                value={departmentForm.phonenumber.value} error={departmentForm.phonenumber.error} onChange={(event) => inputChange("phonenumber", event)} />
                        </div>
                    </div>
                    <div style={{ padding: '0px 20px 0px 20px' }}>
                        <div className="mt-5" style={{ textAlign: 'center', width: '100%' }}>
                            <p style={{ color: message.type === 'success' ? 'green' : '#A50050' }}>{message.message}</p>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer className="d-flex" style={{ justifyContent: 'center' }}>
                    {
                        departmentDetailData.id ?
                        <Button disabled={!formValid || formLoading} onClick={() => addOrUpdateDepartment(true)}>Update Department</Button> :
                        <>
                            <Button disabled={!formValid || formLoading} onClick={() => addOrUpdateDepartment(false, true)}>Create Department and Add Another</Button>
                            <Button disabled={!formValid || formLoading} onClick={() => addOrUpdateDepartment(false, false, true)}>Create Department and Load Programmes</Button>
                        </>
                    }
                </Modal.Footer>
            </Modal>

        </div>
    );
}

export default Department;
